import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero, seleccionarCampo } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoOrdenesdeCompraDevolver from '../../catalogos/catalogoOrdenesdeCompraDevolver';

export const ModalAgregarFactu = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
    const anioefis = JSON.parse(localStorage.getItem('efiscalanio'));

    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(true);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [montoFactu, setMontoFactu] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [datos, setDatos] = useState();
    const [idFactxOrden, setIdFactxOrden] = useState(0);
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const chkManual = useRef();
    const txtNumOperacion = useRef();
    const txtNumFactura = useRef();
    const txtNumControl = useRef();
    const txtFecha = useRef();
    const txtSubTotal = useRef();
    const txtOtros = useRef();
    const txtAjustes = useRef();
    const txtExento = useRef();
    const txtBaseImponible = useRef();
    const txtPorceIva = useRef();
    const txtMontoIva = useRef();
    const txtTotal = useRef();

    const txtMotivo = useRef();
    const txtIdordenpago = useRef();


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
        setDeshabilitado(true);
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onDatos(datos);
        props.onHideCancela();
        blanquear();
      
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof event.which === "undefined") {
            /* if (event.target.value === "" || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.0) {
                event.target.value = "0,00";
            } */
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            
            if (chkManual.current.checked === false) {
                calcular();
            }
            if (event.which === 13) {
                if (event.target.id === 'subtotal') {
                    /*if (chkManual.current.checked === false) {
						calcular();
					}*/                   
                    txtOtros.current.focus();
                } else if (event.target.id === 'otros') {
                    /*if (chkManual.current.checked === false) {
						calcular();
					}*/
                    txtAjustes.current.focus();
                } else if (event.target.id === 'ajustes') {
                    /*if (chkManual.current.checked === false) {
						calcular();
					}*/
                    txtExento.current.focus();
                } else if (event.target.id === 'exento' && chkManual.current.checked) {
                    txtBaseImponible.current.focus();
                } else if (event.target.id === 'exento' && !chkManual.current.checked) {
                    //calcular();
                    txtPorceIva.current.focus();
                } else if (event.target.id === 'baseimponible') {
                    /*if (chkManual.current.checked === false) {
						calcular();
					}*/
                    txtPorceIva.current.focus();
                } else if (event.target.id === 'porceiva'&& chkManual.current.checked) {
                    /*if (chkManual.current.checked === false) {
						calcular();
					}*/
                    txtTotal.current.focus();
                } else if (event.target.id === 'porceiva'&& !chkManual.current.checked) {
                    /*if (chkManual.current.checked === false) {
						calcular();
					}*/
                    btnAcepta.current.focus()
                } else if (event.target.id === 'total') {
                    btnAcepta.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };


    const handleInputNumChange = (event) => {
        event.preventDefault();
        if (event.target.id === 'numoperacion') {
            validaSoloNumero(event);
        }

        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.which === 13) {
                if (event.target.id === 'numoperacion') {
                    txtNumFactura.current.focus();
                } else if (event.target.id === 'numfactura') {
                    txtNumControl.current.focus();
                } else if (event.target.id === 'numcontrol') {
                    txtFecha.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleInputChange = (event) => {
        event.preventDefault();

        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.which === 13) {
                if (event.target.id === 'fecha') {
                    txtSubTotal.current.focus();
                } 
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const seleccionarOrdenesCompras = (id) => {

        let endpoint = `${op.conexion}/api/administracion/registrosordencompracatid?id=${id}&idefiscal=${idefiscal}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                if (response.data.idordenpago > 0) {
                    setActivate(false);
                    txtNumFactura.current.value = response.data.numordenpago;
                    txtExento.current.value = response.data.concepto.trim();
                    txtNumControl.current.value = response.data.idcompromiso;
                    txtSubTotal.current.value = response.data.razonsocial.trim();
                    txtOtros.current.value = response.data.idproveedor;
                    txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                    txtAjustes.current.value = response.data.ubicacion;
                    txtIdordenpago.current.value = response.data.idordenpago;
                    txtTotal.current.value = response.data.tipo;
                    setActivo(false);
                } else {
                    txtNumFactura.current.value = '';
                    txtExento.current.value = '';
                    txtNumControl.current.value = '';
                    txtSubTotal.current.value = '';
                    txtOtros.current.value = '';
                    txtFecha.current.value = '';
                    txtAjustes.current.value = '';
                    txtIdordenpago.current.value = '';
                    txtTotal.current.value = '';
                    setActivo(true);
                }

            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const handleSolicitudes = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarOrdenesCompras(event.target.value);
            }
        }
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (props.facturas && props.facturas.length > 0 && props.operacion === 1){
            for (let i = 0; i < props.facturas.length; i++) {
                if(props.facturas[i].numfactura === txtNumFactura.current.value){
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'LA FACTURA YA EXISTE', icono: 'informacion' });
                    txtNumFactura.current.value = '';
                    return;
                }
            }
        }
        var montoF = parseFloat(txtTotal.current.value.trim().replace(/\./g, "").replace(",", ".")) + parseFloat(montoFactu);
        montoF = Math.round(parseFloat(montoF) * Math.pow(10, 4)) / Math.pow(10, 4);
        var porceIva = parseFloat(txtPorceIva.current.value.trim().replace(/\./g, "").replace(",", "."));
        porceIva = Math.round(parseFloat(porceIva) * Math.pow(10, 4)) / Math.pow(10, 4);
        if (txtNumOperacion.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Por Favor Introduzca el Numero de Operación de la Factura', icono: 'informacion' });
			sigue = false;
			txtNumOperacion.current.focus();
			
		} else if (txtNumFactura.current.value.trim() === '' || txtNumFactura.current.value.trim() === '0') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Por Favor Introduzca el Número de la Factura', icono: 'informacion' });
			sigue = false;
			txtNumFactura.setFocus();
			
		} else if (txtFecha.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La fecha de la factura no es valida', icono: 'informacion' });
			sigue = false;
			txtFecha.current.focus();
		} else if (new Date(txtFecha.current.value).getFullYear() !== anioefis) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El año no debe ser diferente al año del Ejercicio Fiscal actual', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        } else if (txtSubTotal.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Por Favor Introduzca el Monto de Pago', icono: 'informacion' });
			sigue = false;
			txtSubTotal.current.focus();

		} else if (txtBaseImponible.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'Monto Invalido', icono: 'informacion' });
			sigue = false;
            txtSubTotal.current.value = '0,00';
			txtSubTotal.current.focus();

		} else if (txtBaseImponible.current.value.trim() === '0,00' && txtExento.current.value.trim() === '0,00' && txtAjustes.current.value.trim() === '0,00') {
            setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'El Monto no Debe ser Igual a Cero', icono: 'informacion' });
			sigue = false;
			txtSubTotal.current.focus();

		} else if ( porceIva > 100.00) {
            setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'El Porcentaje de IVA no puede ser mayor al 100%', icono: 'informacion' });
			sigue = false;
			txtPorceIva.current.focus();
		} else if ( montoF > props.montoorden) {
            setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'El Monto Facturado es Mayor al Monto Total de la Orden de Pago', icono: 'informacion' });
			sigue = false;
			txtSubTotal.current.focus();
		}       
        
        if (sigue) {

            seleccionarFactura();

        }

    };

    const seleccionarFactura = () => {
        blanquear();
        var data = [];

        data.push({
            idfacturaxorden: idFactxOrden,
            numoperacion: txtNumOperacion.current.value,
            numfactura: txtNumFactura.current.value,
            numcontrol: txtNumControl.current.value,
            fecfactura: txtFecha.current.value,
            subtotal: parseFloat(txtSubTotal.current.value.replace(/\./g, '').replace(',', '.')),
            otros: parseFloat(txtOtros.current.value.replace(/\./g, '').replace(',', '.')),
            ajuste: parseFloat(txtAjustes.current.value.replace(/\./g, '').replace(',', '.')),
            exento: parseFloat(txtExento.current.value.replace(/\./g, '').replace(',', '.')),
            baseimponible: parseFloat(txtBaseImponible.current.value.replace(/\./g, '').replace(',', '.')),
            porceiva: parseFloat(txtPorceIva.current.value.replace(/\./g, '').replace(',', '.')),
            total: parseFloat(txtTotal.current.value.replace(/\./g, '').replace(',', '.')),
        });
        setDatos(data);
        let msg = ''
        if (props.operacion === 1) {
            msg = 'registro creado correctamente.';
        } else if (props.operacion === 2) {
            msg = 'registro modificado correctamente.';
        } else if (props.operacion === 3) {
            msg = 'registro eliminado correctamente.';
        }
        setMensaje({ mostrar: true, titulo: 'Exito.', texto: msg, icono: 'exito' });
    };

    const onCheck = () => {

        if (chkManual.current.checked) {
            setDeshabilitado(false);
        } else {
            setDeshabilitado(true);
        }

    }

    const calcular = () => {
        let TotalBase = parseFloat(txtSubTotal.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtOtros.current.value.replace(/\./g, '').replace(',', '.')) - parseFloat(txtAjustes.current.value.replace(/\./g, '').replace(',', '.')) - parseFloat(txtExento.current.value.replace(/\./g, '').replace(',', '.'));
        TotalBase = Math.round(parseFloat(TotalBase) * Math.pow(10, 4)) / Math.pow(10, 4);

        if (TotalBase < 0.00){
            txtBaseImponible.current.value = '0,00';
        } else {
            txtBaseImponible.current.value = formatMoneda(TotalBase.toString().replace('.', ','), ',', '.', 2);
        }
        
        
        let totaliva = espiritu === 2 ?  (parseFloat(txtPorceIva.current.value.replace(/\./g, '').replace(',', '.'))/100) * (TotalBase) : (parseFloat(txtPorceIva.current.value.replace(/\./g, '').replace(',', '.'))/100) * (TotalBase + parseFloat(txtAjustes.current.value.replace(/\./g, '').replace(',', '.')));
        totaliva = Math.round(parseFloat(totaliva) * Math.pow(10, 4)) / Math.pow(10, 4);

        let totfac = totaliva + TotalBase + parseFloat(txtExento.current.value.replace(/\./g, '').replace(',', '.'));
        totfac = Math.round(parseFloat(totfac) * Math.pow(10, 4)) / Math.pow(10, 4);

        txtTotal.current.value = formatMoneda(totfac.toString().replace('.', ','), ',', '.', 2);
    };

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setActivo(false);
                
                if (props.operacion === 1) {
                    setIdFactxOrden(0);
                    setMontoFactu(parseFloat(props.totalfactu));
                    chkManual.current.checked = false;
                    txtNumFactura.current.value = '';
                    txtNumControl.current.value = '';
                    txtFecha.current.value = moment.utc(fechasistema).format('YYYY-MM-DD');
                    txtSubTotal.current.value = '0,00';
                    txtOtros.current.value = '0,00';
                    txtAjustes.current.value = '0,00';
                    txtExento.current.value = '0,00';
                    txtBaseImponible.current.value = '0,00';
                    txtPorceIva.current.value = '0,00';
                    txtTotal.current.value = '0,00';
                } else {
                    setMontoFactu(parseFloat(props.totalfactu) - parseFloat(props.facturasel.total));
                    setIdFactxOrden(props.facturasel.idfacturaxorden);
                    chkManual.current.checked = false;
                    txtNumOperacion.current.value = props.facturasel.numoperacion;
                    txtNumFactura.current.value = props.facturasel.numfactura;
                    txtNumControl.current.value = props.facturasel.numfactura;
                    txtFecha.current.value = moment.utc(props.facturasel.fecfactura).format('YYYY-MM-DD');
                    txtSubTotal.current.value = formatMoneda(props.facturasel.subtotal.toString().replace('.', ','), ',', '.', 2);;
                    txtOtros.current.value = formatMoneda(props.facturasel.otros.toString().replace('.', ','), ',', '.', 2);;
                    txtAjustes.current.value = formatMoneda(props.facturasel.ajuste.toString().replace('.', ','), ',', '.', 2);;
                    txtExento.current.value = formatMoneda(props.facturasel.exento.toString().replace('.', ','), ',', '.', 2);;
                    txtBaseImponible.current.value = formatMoneda(props.facturasel.baseimponible.toString().replace('.', ','), ',', '.', 2);
                    txtPorceIva.current.value = formatMoneda(props.facturasel.porceiva.toString().replace('.', ','), ',', '.', 2);;
                    txtTotal.current.value = formatMoneda(props.facturasel.total.toString().replace('.', ','), ',', '.', 2);;
                }

            }}

        >
            <Modal.Header className='azulGradiant px-4 py-2'>
                <h3 className='fs-4 m-0 text-light fw-bold'>Factura</h3>
                <button className="bg-light btn btn-sm"onClick={cancelar}>
                    <i className="far fa-times"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='col-md-12 row mx-auto px-0'>
                    <div className='col-md-12 mx-auto'>
                        <div class="form-check mx-auto mb-2">
                            <input class=" my-auto form-check-input" type="checkbox" onChange={onCheck} ref={chkManual} id="manual" />
                            <label class=" my-auto form-check-label" for="flexCheckDefault">
                                Manual
                            </label>
                        </div>

                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">N°Operacion</span>
                        <input type="text" ref={txtNumOperacion} onKeyUp={handleInputNumChange} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="numoperacion"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">N° de Factura</span>
                        <input type="text" ref={txtNumFactura} onKeyUp={handleInputNumChange} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="numfactura"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">N° de Control</span>
                        <input type="text" ref={txtNumControl} onKeyUp={handleInputNumChange} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="numcontrol"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Fecha</span>
                        <input type="date" ref={txtFecha} onKeyUp={handleInputChange} class="form-control text-uppercase" defaultValue={moment.utc(fechasistema).format('DD/MM/YYYY')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="fecha"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Sub-Total</span>
                        <input type="text" ref={txtSubTotal} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="subtotal"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Otros</span>
                        <input type="text" ref={txtOtros} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="otros"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Ajustes</span>
                        <input type="text" ref={txtAjustes} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="ajustes"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Exento</span>
                        <input type="text" ref={txtExento} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="exento"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Base Imponible</span>
                        <input type="text" ref={txtBaseImponible} disabled={deshabilitado} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="baseimponible"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">%IVA</span>
                        <input type="text" maxLength={6} ref={txtPorceIva} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="porceiva"/>
                    </div>
                    <div class="input-group input-group-sm mb-1 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Total Factura</span>
                        <input type="text" ref={txtTotal} disabled={deshabilitado} class="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="total"/>
                    </div>



                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={activo} className="fw-bold btn btn-primary btn-sm rounded"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} className="fw-bold btn btn-sm bg-light rounded"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}